import { FETCH_GET_ERROR_CODE } from '@/constants/common/errorCode'
import { handleError } from '../util/errorHandler'
import { useS3Accessor } from './common/useS3Accessor'
import MiiaFwConfig from '@/configs/config'

/**
 * S3に画像ファイルを保存する
 * @param prefix ディレクトリパス
 * @param fileName ファイル名
 * @param fileData File
 * @return Promise<void>
 */
export const uploadImageToS3 = async (
  prefix: string,
  fileName: string,
  fileData: File
): Promise<void> => {
  const bucketParam = {
    name: MiiaFwConfig.config.s3Access.contentsBucket,
    prefix: prefix,
    delimiter: '/'
  }
  const { uploadFile } = useS3Accessor()
  return await uploadFile(bucketParam, fileName, fileData)
}

/**
 * S3から画像ァイルを削除する
 * @param objectKey S3オブジェクトキー
 */
export const deleteImageFromS3 = async (prefix: string, fileName: string): Promise<void> => {
  const bucketParam = {
    name: MiiaFwConfig.config.s3Access.contentsBucket,
    prefix: prefix,
    delimiter: '/'
  }
  const { deleteFile } = useS3Accessor()
  await deleteFile(bucketParam, fileName)
}

/**
 * S3 Bucket からオブジェクトをダウンロードする。
 * @param presignedUrl 証明書付きURL
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const downloadObject = async (presignedUrl: string): Promise<any> => {
  return await fetch(presignedUrl)
    .then(async res => {
      // fetchは400番系などのエラーが出てもthenに入るので、okプロパティでレスポンスが正常かどうかを判定する
      if (res.ok) return res
      else
        return await handleError(
          FETCH_GET_ERROR_CODE,
          'S3 Bucketからのダウンロードに失敗しました。'
        )
    })
    .catch(async err => {
      console.error(err)
      return await handleError(FETCH_GET_ERROR_CODE, 'S3 Bucketからのダウンロードに失敗しました。')
    })
}
